export default __webpack_public_path__ + "static/media/68.3372e656.jpg";